export default __webpack_public_path__ + "static/media/exploded-view_sprite.6392f292.png";